<template>
    <div class="desc_slide">
        <div class="top_title" id="header" :style="width">
            <div class="title_slide"
                :class="{'title_slide_de':activeColor==index}"  
                v-for="(item, index) in topTitle" 
                @click="changeTitle(index)">
                <div class="mid_bor">{{item}}</div>
            </div>
        </div>
        <div class="btm_content">
            <div class="title_img">
                <img src="@/assets/newmember/titleImg.jpg" alt="">
            </div>
            <div class="img" v-for="imgL in imgList">
                <img :src="imgL" alt="">
            </div>
        </div>
    </div>
</template>

<script>
 import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
    computed: {
        width() {
            var width = {
                width: document.body.clientWidth + 'px'
            }
            return width
        }
    },
    created () {
      window.addEventListener('scroll', this.handleScroll)
    },
    data() {
        return {
            topTitle: ['试吃体验', '专属购物节', '新品尝鲜', '折上9.5折', '最高两倍积分', '专属客服',
                        '生日专享券', '免费退换货', '直属团购价', '优惠可叠加', '百元购物卡', '分享赚佣金'],
            defaureColor: 0,
            activeColor: 0,
            bannerSwiper: {
                loop: true,
                init() {
                }
            },
            imgList: [
                require('@/assets/newmember/v1.jpg'),
                require('@/assets/newmember/v2.jpg'),
                require('@/assets/newmember/v3.jpg'),
                require('@/assets/newmember/v4.jpg'),
                require('@/assets/newmember/v5.jpg'),
                require('@/assets/newmember/v6.jpg'),
                require('@/assets/newmember/v7.jpg'),
                require('@/assets/newmember/v8.jpg'),
                require('@/assets/newmember/v9.jpg'),
                require('@/assets/newmember/v10.jpg'),
                require('@/assets/newmember/v11.jpg'),
                require('@/assets/newmember/v12.jpg'),
            ],
            isClickColor: true
        }
    },
    methods: {
        // 点击顶部标题
        changeTitle(index) {
            this.defaureColor = index
            this.isClickColor = false
            this.activeColor = index
        },
        // 监听页面滚动
        handleScroll() {
            this.$nextTick(() => {
                let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
                let headerTop = document.getElementById("header").offsetTop
                // 监听滚动事件、
                let contentItem = document.querySelectorAll('.img')
                if(this.isClickColor) {
                    contentItem.forEach((item, index) => {
                        if (scrollTop >= (item.offsetTop-40)) {
                            // this.defaureColor = index
                            this.activeColor = index
                        }
                    })
                } else {
                    this.isClickColor = true
                }
            })
        }
    },
    watch: {
        defaureColor(val) {
            const anchor  = document.querySelectorAll('.img')[val];
            document.body.scrollTop = anchor.offsetTop-40 // chrome
            document.documentElement.scrollTop = anchor.offsetTop-40 // firefox
        },
        activeColor(val) {
            // let active = document.querySelectorAll('.title_slide')[val]
            // console.log(active.offsetLeft)
            // active.scrollLeft = 180
            // console.log(active.scrollLeft)
        }
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll)
    }
}

</script>

<style lang="less" scoped>
.desc_slide{
    width: 100%;
    height: 100%;
}
.top_title{
    display: flex;
    font-size: 0.26rem;
    background: #394050;
    color: #fff;
    // width: 10rem;
    justify-content: space-between;
    overflow-x: scroll;
    overflow-y:hidden;
    position: fixed;
    top: 0;
    &::-webkit-scrollbar{
        display: none;
    }
    .title_slide{
        height: 0.8rem;
        .mid_bor{
            border-right: 1px solid #fff;
            height: 0.4rem;
            width: 2rem;
            text-align: center;
            line-height: 0.4rem;
            margin-top: 0.2rem;
        }
    }

    .title_slide_de{
        background: #ffcd46;
        .mid_bor{
            border-right: 0 none;
        }
    }
}
.btm_content{
    font-size: 0;
    margin-top: 0.8rem;
}

</style>


// WEBPACK FOOTER //
// src/component/slidePage/index.vue